<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formBussinessDocumentsType">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>
          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="delete()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="bussinessDocumentsTypeContract.userNameCreate"
              [createDate]="bussinessDocumentsTypeContract.createDate"
              [userNameUpdate]="bussinessDocumentsTypeContract.userNameUpdate"
              [updateDate]="bussinessDocumentsTypeContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col field-bussinessDocumentsClassId">
              <app-custom-select formControlName="bussinessDocumentsClassId" [labelText]="'Clase'"
                [list]="listBussinessClasss" [recovery]="true" [required]="true"
                (onChangeSelect)="changeBussinessDocumentsClass($event)"></app-custom-select>
            </div>
            <div class="col field-branchId">
              <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                [recovery]="true" [required]="true" (onChangeSelect)="changeBranch($event, false)"></app-custom-select>
            </div>
            <div class="col field-enterpriseId">
              <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
                [recovery]="true" [required]="true" (onChangeSelect)="changeEnterprise($event)"></app-custom-select>
            </div>
            <div class="col field-code">
              <app-custom-input-number formControlName="code" [labelText]="'Código'" [required]="true" [recovery]="true"
                (onChangeNumber)="changeCode($event)"></app-custom-input-number>
            </div>
            <div class="col field-alterCode">
              <app-custom-input-text formControlName="alterCode" [labelText]="'Cód. Alterno'" [maxLength]="4">
              </app-custom-input-text>
            </div>
            <div class="col field-bussinessDocumentsDianTypeId">
              <app-custom-select formControlName="bussinessDocumentsDianTypeId" [labelText]="'Tipo DIAN'"
                [list]="listBusinessDianTypes" [required]="true"></app-custom-select>
            </div>
            <div class="col field-description">
              <app-custom-input-text formControlName="description" [labelText]="'Nombre Tipo Doc.Com.'"
                [required]="true" [maxLength]="50">
              </app-custom-input-text>
            </div>
            <div class="col field-cxcInvoiceConcept">
              <app-custom-input-text formControlName="cxcInvoiceConcept" [labelText]="'Concepto CxC Fra'"
                [maxLength]="10">
              </app-custom-input-text>
            </div>
            <div class="col field-cxcDebitNoteConcept">
              <app-custom-input-text formControlName="cxcDebitNoteConcept" [labelText]="'Conc. CxC N.Déb'"
                [maxLength]="10">
              </app-custom-input-text>
            </div>
            <div class="col field-cxcCreditNoteConcept">
              <app-custom-input-text formControlName="cxcCreditNoteConcept" [labelText]="'Conc. CxC N.Créd'"
                [maxLength]="10">
              </app-custom-input-text>
            </div>
            <div class="col field-state">
              <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateBussinessDocumentsType">
              </app-custom-tag>
            </div>
            <div class="col field-button-state">
              <app-custom-button [title]="titleState" [icon]="'pi pi-undo'" [severity]="'primary'"
                (onClick)="changeStateBussinessDocumentsType()">
              </app-custom-button>
            </div>
            <div class="col field-button-send">
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledForm" (onClick)="send()">
              </app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>